import { useLingui } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import { Button } from '@utima/ui';

import { useCurrentOrganization } from '@/hooks/useCurrentOrganization';

export function UsageLimitBanner() {
  const { t } = useLingui();
  const { organization } = useCurrentOrganization();

  if (!organization) {
    return null; // Exit if no organization data
  }

  const allowanceDepleted =
    organization.currentMonthlyUsage >= organization.monthlyUsageLimit;
  const balanceDepleted = organization.balance <= 0;

  // Only show banner if allowance is used AND balance is depleted
  if (!allowanceDepleted || !balanceDepleted) {
    return null;
  }

  return (
    <div
      className='mb-4 rounded-md bg-red-100 p-4'
      role='alert'
      aria-live='polite'
    >
      <div className='flex items-center justify-between gap-4'>
        <div className='flex-1'>
          <h4 className='mb-1 text-sm font-semibold text-danger'>
            {t`Usage limit reached`}
          </h4>
          <p
            className='text-sm text-danger/90'
            aria-describedby='usage-limit-action'
          >
            {t`Your organization has reached its monthly usage limit. Some features may be restricted. Please increase your limit to continue using all features.`}
          </p>
        </div>
        <Button
          data-cta='admin-usage-limit-banner-increase-limit-button'
          variant='danger'
          asChild
        >
          <Link
            id='usage-limit-action'
            to='/organizations/$organizationId/payments'
            params={{ organizationId: organization.id }}
          >
            {t`Increase limit`}
          </Link>
        </Button>
      </div>
    </div>
  );
}
